import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import { debounceIndexEmployeeDncRequest } from '../../../requests/trainingPrograms';
import { ComponentDataTable, SimpleSelect } from '../../../components';
import columns from './columns';

const DncProfileIndex = () => {
  const currentYear = moment().year();
  const [employeeDncs, setEmployeeDncs] = useState([]);
  const [onRequest, setOnRequest] = useState(true);
  const [amount, setAmount] = useState(0);
  const [moreData, setMoreData] = useState(false);
  const [customParams, setCustomParams] = useState({ filter_year: currentYear, mine: true });

  const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() });
  const [yearsOptions, setYearsOptions] = useState([
    { label: currentYear.toString(), value: currentYear.toString() }
  ]);
  const dispatch = useDispatch();

  const handleIndexRequest = params => {
    setOnRequest(true);
    const request = async () =>
      debounceIndexEmployeeDncRequest({
        dispatch,
        params: { ...params, ...customParams },
        successCallback: response => {
          const { data, metadata } = response.data;
          setEmployeeDncs(data);
          setAmount(metadata.amount);
          if (metadata.years && metadata.years.length > 0) {
            const formattedYears = metadata.years.map(y => ({ label: y.toString(), value: y.toString() }));
            setYearsOptions(formattedYears);
          }
        },
        callback: () => setOnRequest(false)
      });
    request();
  };

  const onFilter = () => {
    setCustomParams({ filter_year: year?.value || currentYear, mine: true });
    setMoreData(!moreData);
  };

  const NoDataComponent = () => (
    <div
      className="w-100 text-center py-3"
      style={{
        backgroundColor: 'white',
        borderLeft: '0.5px solid #f3b34d',
        borderRight: '0.5px solid #f3b34d',
        borderBottom: '0.5px solid #f3b34d',
        borderRadius: '0 0 4px 4px',
        color: '#8d8c8c',
        fontSize: '13px'
      }}
    >
      No se Encontraron Datos
    </div>
  );

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col md={8}>
          <h2 className="mb-0 mt-3">Programa de Capacitación</h2>
        </Col>
      </Row>
      <div className="yellow-wrapper mt-5 p-3">
        <div className="mx-0 mb-4 border p-3 rounded bg-white shadow-sm">
          <Row className="align-items-end">
            <Col md={3}>
              <p className="mb-1 font-weight-bold" style={{ fontSize: '13px' }}>
                Año:<span className="text-danger">*</span>
              </p>
              <SimpleSelect options={yearsOptions} value={year} onChange={data => setYear(data)} isClearable={false} />
            </Col>
            <Col className="d-flex justify-content-end">
              <Button variant="success" className="px-5 font-weight-bold" onClick={onFilter}>
                FILTRAR
              </Button>
            </Col>
          </Row>
        </div>

        <div className="data-table-yellow">
          <ComponentDataTable
            onRequest={onRequest}
            columns={columns()}
            data={employeeDncs}
            totalRows={amount}
            resourceRequest={handleIndexRequest}
            moreData={moreData}
            pointerOnHover
            withSearch={false}
            persistTableHead
            noDataComponent={<NoDataComponent />}
            customSpinnerClass="containerSpinnerLoad h-100 w-100 d-flex align-items-center justify-content-center"
          />
        </div>
      </div>
    </>
  );
};

export default DncProfileIndex;
